import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

interface ActionsFormManager {
  add: () => void;
  delete: (index: number) => void;
}

@Component({
  selector: 'app-remarks-modal',
  templateUrl: './remarks-modal.component.html',
  styleUrls: ['./remarks-modal.component.scss']
})
export class RemarksModalComponent implements OnInit {
  @Output() remarksAdded: EventEmitter<string[]> = new EventEmitter();
  public isOpen = true;
  public form: FormGroup;

  get formManager(): ActionsFormManager {
    return {
      delete: this.delete.bind(this),
      add: this.add.bind(this)
    };
  }

  ngOnInit() {
    this.buildForm();
  }

  handleToggle(): void {
    this.isOpen = !this.isOpen;
  }

  handleAccept(): void {
    this.formManager.add();
    this.remarksAdded.emit(this.form.getRawValue().remarks);
    this.handleToggle();
  }

  trackIndex(index: number): number {
    return index;
  }

  private buildForm() {
    this.form = new FormGroup({
      remarks: new FormArray([]),
      remarkTemp: new FormControl(null)
    });
  }

  private add(): void {
    if (this.validateRemark()) {
      return;
    }

    const remarks = new FormArray([
      ...[...this.form.controls.remarks.value, this.form.controls.remarkTemp.value.trim()].map(
        (item: string) => new FormControl(item)
      )
    ]);
    this.form.setControl('remarks', remarks);
    this.form.controls.remarkTemp.reset();
  }

  private delete(index: number): void {
    const remarks = new FormArray([
      ...this.form.controls.remarks.value
        .filter((_, i) => i !== index)
        .map((item: string) => new FormControl(item))
    ]);
    this.form.setControl('remarks', remarks);
  }

  private validateRemark(): boolean {
    const remark = this.form.controls.remarkTemp.value;
    return !remark || this.form.controls.remarks.value.some((value) => value === remark);
  }
}
